import cx from 'classnames';
import PropTypes from 'prop-types';

import H2 from 'core/components/H2';
import withTheme from 'core/hocs/withTheme';

import { topicDateFormat } from 'core/utils/dates';

import styles from './index.styl';

function TopicsList(props) {
  const {
    topics,
    theme,
    pickedTopicIndex,
    pickTopic,
  } = props;

  if (!topics || !topics.length || pickedTopicIndex !== null) return null;

  const {
    texts: {
      caption1: {
        font: captionFont,
      },
      title1: {
        font: titleFont,
      },
    },
    colors: {
      active1,
      accent,
    },
  } = theme;

  return (
    <div className={cx(styles.topicsListWrapper)}>
      <style jsx>{`
        .${styles.listWrapper}
          font ${captionFont}

        .${styles.card}
          &::before
            font italic ${titleFont}
            color ${accent}

        .${styles.cardTitle}
          .cardContent:hover &
            color ${active1}

        .${styles.cardDate}
          color ${theme.colors.placeholder}

      `}</style>
      <H2 className={styles.title}>Читать офлайн</H2>
      <ol
        className={styles.listWrapper}
        onClick={pickTopic}
        role='list'
      >
        {topics.map((data, i) => (
          <li
            className={styles.card}
            key={i}
            data-idx={i}
          >
            <div className='cardContent'>
              <time className={styles.cardDate}>{topicDateFormat(data.attributes.published_at)}</time>
              <div className={styles.cardTitle}>{data.attributes.headline}</div>
              <div className={styles.cardSubtitle}>{data.attributes.alternative_headline}</div>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}

TopicsList.propTypes = {
  /**
   * Офлайн-топики предзагруженные в localStorage
   */
  topics: PropTypes.array,
  /** @ignore */
  theme: PropTypes.object,
  /**
   * Индекс просматриваемого топика из localStorage.
   *
   * В текущем списковом компоненте используется для проверки,
   * что мы не в режиме просмотра одного топика.
   */
  pickedTopicIndex: PropTypes.number,
  /**
   * Обработчик позволяющий переключить состояние на просмотр конкретного топика
   */
  pickTopic: PropTypes.func.isRequired,
};

const TopicsListWithHOCs = withTheme(TopicsList);
TopicsListWithHOCs.displayName = 'TopicsList';

export { TopicsList as StorybookComponent };
export default TopicsListWithHOCs;
